import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { X, Plus, Save, RefreshCw } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const MembershipEditorShared = ({ plan, onSave, hideFinancials }) => {
  const [form, setForm] = useState({ ...plan, features: [...(plan.features || [])] });
  const [saving, setSaving] = useState(false);
  const [newFeature, setNewFeature] = useState('');

  const addFeature = () => { if (newFeature.trim()) { setForm({ ...form, features: [...form.features, newFeature.trim()] }); setNewFeature(''); } };
  const removeFeature = (i) => { setForm({ ...form, features: form.features.filter((_, idx) => idx !== i) }); };

  const handleSave = async () => {
    setSaving(true);
    await onSave({ ...form, price: parseFloat(form.price), downloads_per_month: parseInt(form.downloads_per_month) });
    setSaving(false);
  };

  return (
    <div className="glass-card p-6" data-testid={`membership-editor-${plan.plan_id}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">{plan.name}</h3>
        <span className="text-xs text-white/40 font-mono">{plan.plan_id}</span>
      </div>
      <div className={`grid grid-cols-1 ${hideFinancials ? 'md:grid-cols-2' : 'md:grid-cols-3'} gap-4 mb-4`}>
        <div><label className="block text-xs text-white/50 mb-1">Nombre del Plan</label>
          <input className="w-full input-glass" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} data-testid={`membership-name-${plan.plan_id}`} /></div>
        {!hideFinancials && (
          <div><label className="block text-xs text-white/50 mb-1">Precio ($/mes)</label>
            <input type="number" step="0.01" className="w-full input-glass" value={form.price} onChange={e => setForm({ ...form, price: e.target.value })} data-testid={`membership-price-${plan.plan_id}`} /></div>
        )}
        <div><label className="block text-xs text-white/50 mb-1">Descargas/mes (-1 = ilimitado)</label>
          <input type="number" className="w-full input-glass" value={form.downloads_per_month} onChange={e => setForm({ ...form, downloads_per_month: e.target.value })} data-testid={`membership-downloads-${plan.plan_id}`} /></div>
      </div>
      <div className="mb-4">
        <label className="block text-xs text-white/50 mb-2">Caracteristicas / Beneficios</label>
        <div className="space-y-2 mb-2">
          {form.features.map((f, i) => (
            <div key={i} className="flex items-center gap-2">
              <input className="flex-1 input-glass text-sm py-2" value={f} onChange={e => { const nf = [...form.features]; nf[i] = e.target.value; setForm({ ...form, features: nf }); }} />
              <button onClick={() => removeFeature(i)} className="p-2 text-red-400 hover:bg-red-500/10 rounded-lg"><X className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
        <div className="flex gap-2">
          <input className="flex-1 input-glass text-sm py-2" placeholder="Agregar caracteristica..." value={newFeature} onChange={e => setNewFeature(e.target.value)} onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), addFeature())} />
          <button onClick={addFeature} className="btn-secondary py-2 px-4 text-sm"><Plus className="w-4 h-4" /></button>
        </div>
      </div>
      <button onClick={handleSave} disabled={saving} className="btn-primary py-2 px-6 text-sm" data-testid={`membership-save-${plan.plan_id}`}>
        <Save className="w-4 h-4 inline mr-2" />{saving ? 'Guardando...' : 'Guardar Plan'}
      </button>
    </div>
  );
};

const PlansPanel = ({ hideFinancials = false }) => {
  const [memberships, setMemberships] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/api/admin/memberships`, { withCredentials: true });
      setMemberships(r.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleSave = async (plan) => {
    try {
      await axios.put(`${API}/api/admin/memberships/${plan.plan_id}`, plan, { withCredentials: true });
      load();
    } catch (err) { alert('Error: ' + (err.response?.data?.detail || err.message)); }
  };

  if (loading) return <p className="text-white/40">Cargando planes...</p>;

  return (
    <div data-testid="plans-panel">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold">Planes de Membresia</h2>
          <p className="text-white/50 text-sm">Edita nombres, limites de descarga y caracteristicas.</p>
        </div>
        <button onClick={load} className="p-2 hover:bg-white/10 rounded-lg text-white/40"><RefreshCw className="w-4 h-4" /></button>
      </div>
      <div className="space-y-6">
        {memberships.map(plan => (
          <MembershipEditorShared key={plan.plan_id} plan={plan} onSave={handleSave} hideFinancials={hideFinancials} />
        ))}
      </div>
      {memberships.length === 0 && <p className="text-center text-white/40 py-8">Sin planes configurados.</p>}
    </div>
  );
};

export default PlansPanel;
